import type { BufferGeometry, Intersection, Material, Raycaster } from 'three'
import { Mesh as TMesh } from 'three'

import { acceleratedRaycast } from 'three-mesh-bvh'

TMesh.prototype.raycast = acceleratedRaycast

class Mesh<
  TGeometry extends BufferGeometry = BufferGeometry,
  TMaterial extends Material | Material[] = Material | Material[],
  > extends TMesh<TGeometry, TMaterial> {
  constructor(geometry?: ConstructorParameters<typeof TMesh>[0], material?: ConstructorParameters<typeof TMesh>[1]) {
    super(geometry as TGeometry, material as TMaterial)
  }

  /**
   * handle mesh raycaster
   * @param raycaster
   * @param intersects
   */
  public raycast(raycaster: Raycaster, intersects: Intersection[]) {
    // if (this.useBvh && this.geometry.boundsTree)
    // acceleratedRaycast.call(this, raycaster, intersects)

    super.raycast(raycaster, intersects)
  }
}

export default Mesh